import React from 'react';
import { BsX } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Box, HStack, Icon, IconButton, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { checkCodeCheckbox } from '../../../../../redux/modules/emails';
import { layerStyles } from '../../../../../styles/theme/foundation/layerStyles';

function SelectedCodeBubble({ id, letter }) {
  const dispatch = useDispatch();
  return (
    <Box
      border="1px solid"
      borderColor={layerStyles.active.main}
      borderRadius="lg"
      layerStyle="active"
      lineHeight="24px"
    >
      <HStack>
        <Text
          color="primaryScale.600"
          fontSize="sm"
          pl={2}
        >
          {letter}
        </Text>
        <IconButton
          icon={<Icon as={BsX} />}
          m={0}
          size="xs"
          variant="textBlack"
          onClick={() => dispatch(checkCodeCheckbox(id, false))}
        />
      </HStack>
    </Box>
  );
}

SelectedCodeBubble.propTypes = {
  id: PropTypes.number.isRequired,
  letter: PropTypes.string.isRequired
};

export default SelectedCodeBubble;
